import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Form } from "reactstrap";
import TextInput from "../../components/InputFields/TextInput";
import { useFormik } from "formik";
import { formikAddOrg, organizationTypeOption, sideTabs } from "./Constant";
import { failed } from "../../utils/Tostify";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import { useGetStates } from "../../hooks/useGetStates";
import "./Organization.css";
import { handleFileUpload } from "../../utils/ImageToBase64";
import organization_icon from "../../assets/images/organization-admin.svg";

function AddOrganization() {
    const [isLoading, setIsLoading] = useState(false);
    const [Countryvalue, setCountryValue] = useState();
    const [stateValue, setStateValue] = useState();
    const [ActiveStep, setActiveStep] = useState(1);
    const [selectedImage, setSelectedImage] = useState();
    const navigate = useNavigate();
    const location = useLocation();
    const fromEdit = location.state?.fromEdit;
    const orgData = location.state?.orgData;
    const { states, countryOptions } = useGetStates(Countryvalue);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [ActiveStep]);

    const formik = useFormik({
        ...formikAddOrg,
        onSubmit: async (values) => {
            let res;
            try {
                let base64OrgLogo = "";
                if (values?.orgLogo?.name !== undefined) {
                    base64OrgLogo = await handleFileUpload(values?.orgLogo);
                    const fileExtension = values?.orgLogo?.type?.split("/")[1];
                    const orgLogoURL = {
                        base64String: base64OrgLogo,
                        extension: fileExtension, // Add the file extension to the object
                        name: values?.orgLogo?.name
                    };
                    values.orgLogo = orgLogoURL;
                }
                localStorage.removeItem("orgId");
                setActiveStep(2);
                navigate("/super-admin/clinicslist", { state: { ActiveStep: 2, orgData: {}, fromEdit: false, fromListing: false, orgValues: formik.values, logoUrl: selectedImage } });
                // }
            } catch (error) {
                setIsLoading(false);
                failed(res?.message);
            }
        }
    });
    const CountrychangeHandler = e => {
        setCountryValue(e.target.value);
        formik.setFieldValue("country", countryOptions.find((obj) => obj.value === e.target.value).label);
    };
    const stateHandler = (e) => {
        setStateValue(e.target.value);
        formik.setFieldValue('state', e.target.value);
    };

    const handleImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setSelectedImage(URL.createObjectURL(e.target.files[0]));
            formik.setFieldValue("orgLogo", e.target.files[0]);
        }
    };

    return (
        <Fragment>
            {isLoading ? <Loader /> : null}
            <div className="organization_form_block organization_blk create-org">
                <div className="d-flex justify-content-between align-items-center main-header-block header-bg">
                    <div className="left_header d-flex align-items-center">
                        <img src={organization_icon} />
                        <h2 className="home-title">Organizations</h2>
                    </div>
                </div>
                <div className="d-flex gap-4 bcd">
                    {sideTabs({ ActiveStep, navigate, fromEdit: fromEdit, orgData })}
                    <div className="forms_block">
                        <Form onSubmit={formik.handleSubmit}>
                            <div className="p-4 modal_change_color rounded">
                                <h2 className="form_title">Create Organization</h2>
                                <div className="abc">
                                    <div className="img_block">
                                        {selectedImage ? (
                                                <img
                                                    src={selectedImage}
                                                    alt="Profile"
                                                    className="img_profile_one"
                                                />
                                            ) : (
                                                <img
                                                    src={"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQslVmzd8LVAjSVrByOoEviDJC-k5fVtP9Q-vO4mzEy3GlmGTf-wy-g-E0QmZ9mPNU95PE&usqp=CAU"} // Placeholder image if none is selected
                                                    className="img_profile_one"
                                                />
                                            )}
                                        <div className="edit_img">
														<i className='fas fa-pen'></i>
													</div>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={handleImageChange}
                                            className="img_upload_input"
                                        />
                                    </div>
                                </div>
                                <div className="first_block">
                                    <Row>
                                        <Col lg={6} className="location_block location_blk">
                                            <TextInput
                                                keyField={"orgName"}
                                                formik={formik}
                                                label="Organization Name"
                                                type="text"
                                                placeholder="Organization Name"
                                                value={formik.values.orgName}
                                                onChange={(e) => formik.setFieldValue("orgName", e.target.value)}
                                            />
                                        </Col>
                                        <Col lg={6} className="location_block location_blk">
                                            <TextInput
                                                keyField={"type"}
                                                formik={formik}
                                                label="Organization Type"
                                                type="select"
                                                options={organizationTypeOption}
                                                value={formik.values.type}
                                                onChange={(e) => formik.setFieldValue("type", e.target.value)}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={6} className="location_block">
                                            <TextInput
                                                keyField={"phone"}
                                                formik={formik}
                                                label="Organization Phone"
                                                type="phone"
                                                placeholder="Phone"
                                                required={false}
                                                value={formik.values.phone}
                                                onChange={(e) => formik.setFieldValue("phone", e)}
                                            />
                                        </Col>
                                        <Col lg={6} className="location_block">
                                            <TextInput
                                                keyField={"email"}
                                                formik={formik}
                                                label="Organization Email"
                                                type="text"
                                                placeholder="Email"
                                                value={formik.values.email}
                                                onChange={(e) => formik.setFieldValue("email", e.target.value)}
                                            />
                                        </Col>
                                    </Row>
                                </div>
                                <div className="first_block modal_change_color">
                                    <Row>
                                        <Col lg={6} className="location_block">
                                            <h6 className="block_name">Primary Contact Person</h6>
                                            <TextInput
                                                keyField={"contactName"}
                                                formik={formik}
                                                label="Name"
                                                type="text"
                                                placeholder="Full Name"
                                                value={formik.values.contactName}
                                                onChange={(e) => formik.setFieldValue("contactName", e.target.value)}
                                            />
                                            <TextInput
                                                keyField={"contactEmail"}
                                                formik={formik}
                                                label="Email"
                                                type="email"
                                                placeholder="Email"
                                                value={formik.values.contactEmail}
                                                onChange={(e) => formik.setFieldValue("contactEmail", e.target.value)}
                                            />
                                            <TextInput
                                                keyField={"contactPhone"}
                                                formik={formik}
                                                label="Phone"
                                                type="phone"
                                                placeholder="Phone"
                                                required={false}
                                                value={formik.values.contactPhone}
                                                onChange={(e) => formik.setFieldValue("contactPhone", e)}
                                            />
                                        </Col>
                                        <Col lg={6} className="location_block">
                                            <h6 className="block_name">Secondary Contact Person (Optional)</h6>
                                            <TextInput
                                                keyField={"secondaryContactName"}
                                                formik={formik}
                                                label="Name"
                                                type="text"
                                                required={false}
                                                placeholder="Full Name"
                                                value={formik.values?.secondaryContactName}
                                                onChange={(e) => formik.setFieldValue("secondaryContactName", e.target.value)}
                                            />
                                            <TextInput
                                                keyField={"secondarycontactEmail"}
                                                formik={formik}
                                                label="Email"
                                                type="email"
                                                placeholder="Email"
                                                required={false}
                                                value={formik.values.secondarycontactEmail}
                                                onChange={(e) => formik.setFieldValue("secondarycontactEmail", e.target.value)}
                                            />
                                            <TextInput
                                                keyField={"secondaryContactPhone"}
                                                formik={formik}
                                                label="Phone"
                                                type="phone"
                                                placeholder="Phone"
                                                required={false}
                                                value={formik.values.secondaryContactPhone}
                                                onChange={(e) => formik.setFieldValue("secondaryContactPhone", e)}
                                            />
                                        </Col>
                                    </Row>
                                </div>
                                <div className="first_block second_block modal_change_color">
                                    <h6 className="block_name">Address Information</h6>
                                    <Row>
                                        <Col lg={12} className="location_block">
                                            <TextInput
                                                keyField={"address"}
                                                formik={formik}
                                                label="Street"
                                                type="text"
                                                placeholder="Street"
                                                value={formik.values.address}
                                                onChange={(e) => formik.setFieldValue("address", e.target.value)}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={6} className="location_block">
                                            <TextInput
                                                keyField={"country"}
                                                formik={formik}
                                                options={countryOptions}
                                                label="Country"
                                                type="select"
                                                placeholder="Country"
                                                value={Countryvalue}
                                                onChange={CountrychangeHandler}
                                            />
                                        </Col>
                                        <Col lg={6} className="location_block">
                                            <TextInput
                                                keyField={"state"}
                                                formik={formik}
                                                label="State"
                                                options={states.map((obj) => {
                                                    return {
                                                        label: obj.name,
                                                        value: obj.name
                                                    };
                                                })}
                                                type="select"
                                                placeholder="State"
                                                value={stateValue}
                                                onChange={stateHandler}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={6} className="location_block">
                                            <TextInput
                                                keyField={"city"}
                                                formik={formik}
                                                label="City"
                                                type="text"
                                                placeholder="City"
                                                value={formik.values.city}
                                                onChange={(e) => formik.setFieldValue("city", e.target.value)}
                                            />
                                        </Col>
                                        <Col lg={6} className="location_block">
                                            <TextInput
                                                keyField={"postalCode"}
                                                formik={formik}
                                                label="Zip Code"
                                                type="text"
                                                placeholder="Zip Code"
                                                value={formik.values.postalCode}
                                                onChange={(e) => formik.setFieldValue("postalCode", e.target.value)}
                                            />
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <div className="d-flex gap-3 justify-content-end mt-4">
                                <button className="save_btn" type="button" onClick={() => navigate("/super-admin/organization")}>Cancel</button>
                                <button className="save_btn" type="submit">Next</button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default AddOrganization;
